import { BaseScreen } from "./BaseScreen";

import type { AuthScreenEvents } from "./components/AuthScreenEvents";

export class SubscribeAuthScreen extends BaseScreen {

    private root!: HTMLElement;

    constructor(
        private readonly events: AuthScreenEvents
    ) {
        super();
    }

    public override mount(): void {

        super.mount();

        this.root =
            this.buildRoot();

    }

    public override update(): void {

        super.update();

        const newRoot =
            this.buildRoot();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    public override unmount(): void {

        super.unmount();

    }

    public getRoot(): HTMLElement {

        return this.root;

    }

    // =========================
    // BUILD
    // =========================

    private buildRoot(): HTMLElement {

        const root =
            document.createElement("div");

        root.className =
            "auth-container";

        const card =
            document.createElement("div");

        card.className =
            "auth-card";

        const logoLink =
            document.createElement("a");

        logoLink.href =
            "https://fr.bezbolu.pro";

        const logo =
            document.createElement("img");

        logo.src =
            "/icons/logo.png";

        logo.className =
            "auth-logo";

        logoLink.appendChild(
            logo
        );

        card.appendChild(
            logoLink
        );

        const welcome =
            document.createElement("div");

        welcome.className =
            "auth-welcome";

        welcome.textContent =
            "Щоб оформити підписку, введіть email";

        card.appendChild(
            welcome
        );

        const email =
            document.createElement("input");

        email.id =
            "auth-email";

        email.type =
            "email";

        email.placeholder =
            "Email";

        card.appendChild(
            email
        );

        const info =
            document.createElement("div");

        info.className =
            "auth-welcome";

        info.textContent =
            "Вам треба підтвердити email. Натисніть на кнопку нижче, щоб отримати код підтвердження на email.";

        card.appendChild(
            info
        );

        const button =
            document.createElement("button");

        button.textContent =
            "Отримати код";

        button.addEventListener(
            "click",
            () => this.submit()
        );

        email.addEventListener(
            "keydown",
            e => {

                if (e.key === "Enter") {
                    this.submit();
                }

            }
        );

        card.appendChild(
            button
        );

        const error =
            document.createElement("div");

        error.id =
            "auth-error";

        error.className =
            "auth-error";

        card.appendChild(
            error
        );

        root.appendChild(
            card
        );

        return root;

    }

    // =========================
    // ACTIONS
    // =========================

    private async submit(): Promise<void> {

        const input =
            this.root.querySelector<HTMLInputElement>(
                "#auth-email"
            );

        const error =
            this.root.querySelector<HTMLElement>(
                "#auth-error"
            );

        const email =
            input?.value.trim() ?? "";

        if (!email) {

            error!.textContent =
                "Введіть email";

            return;

        }

        await this.events.submit(
            email
        );

    }

}